export var isFareLockService = function (service) {
    return service.isPriceFreeze || 'freezeUntil' in service;
};
